import { observer } from 'mobx-react-lite';
import React from 'react';
import FilmReportDynamicTable from './FilmReportDynamicTable';
import FilmReportMetadataDynamicTable from './FilmReportMetadataDynamicTable';
import {
  FilmData,
  label,
} from '../../../app/stores/FilmAnaysisAndRepairReport/types';
interface RenderComponent {
  title: string;
  elements: any;
  metadata?: any[];
  firstComponent?: boolean;
  elementObject?: any[];
  dryingOrDesiccation?: any;
  indexValue?: Number;
}

interface LastRenderComponent {
  title: string;
  elementObject?: FilmData[];
}

const commonStyles = `
  * {
    font-size: 10px;
    text-transform:uppercase;
  }
  #container {
    margin: 0% 10%;
  }
  .text-center {
    text-align: center;
  }
  .underline-heading {
    padding-top: 20px;
    text-decoration: underline;
  }
  .underline {
    text-decoration: underline;
  }
  .center-content {
    text-align: center;
  }
  .table,
  .table th,
  .table td {
    border: 1px solid medium grey;
    border-collapse: collapse;
  }
  .table td {
    padding: 4px;
  }
  .table table,
  .table table th,
  .table table td {
    border: none;
    border-collapse: collapse;
  }
  .bold {
    font-weight: 700;
  }
  .table-td-key {
    font-weight: 700;
    text-align: left;
    padding-right: 8px;
  }
  .table-td-value {
    text-align: left;
  }
  .padding-left { 
    padding-right:140px;
    // padding-left:10px;
  }
  .padding-Right { 
    padding-left:20px;
  }
`;
// eslint-disable-next-line
const RenderComponent: React.FC<RenderComponent> = ({
  // eslint-disable-next-line
  title,
  elements,
  firstComponent = false,
  elementObject,
  indexValue,
  dryingOrDesiccation,
}) => (
  <html>
    <style>{commonStyles}</style>
    <body>
      <div id="container">
        {firstComponent && (
          <>
            <table className="text-center">
              <br />
              <tr style={{ height: '60px', marginLeft: '8%' }}>
                <td style={{ marginRight: '35%' }}>
                  <img
                    src="/assets/PrasadCorp.jpg"
                    alt="logo"
                    className="image-align"
                    style={{ width: '60%' }}
                  />
                </td>
                <td>
                  <img
                    src="https://res.cloudinary.com/drvaemi9t/image/upload/v1697024835/rucvkllx5mmpc0o5mnyx.jpg"
                    alt="logo"
                    className="image-align"
                    style={{ width: '70%' }}
                  />
                </td>
              </tr>
            </table>
            <div
              className="center-content underline-heading bold"
              style={{ fontSize: '13px' }}
            >
              FILM ANALYSIS & REPAIR REPORT
            </div>
          </>
        )}
        {title && (
          <div className=" bold " style={{ fontSize: '12px' }}>
            {!elementObject ? (
              <>
                <br />
                {title}
              </>
            ) : (
              <>
                <br />
                <br />
                {title}
              </>
            )}
          </div>
        )}
        {elements.map((element: any, index: number) => (
          <div key={index}>
            <br />
            <FilmReportDynamicTable elementObject={element} />
          </div>
        ))}
        {elementObject && (
          <>
            <br />
            <FilmReportMetadataDynamicTable
              elementObject={elementObject}
              indexValue={indexValue as number}
              dryingOrDesiccation={dryingOrDesiccation}
            />
          </>
        )}
      </div>
    </body>
  </html>
);

export default observer(RenderComponent);

// eslint-disable-next-line
export const LastRenderComponent: React.FC<LastRenderComponent> = ({
  title,
  elementObject,
}) => (
  <html>
    <style>{commonStyles}</style>
    <body>
      {title && (
        <div className=" bold" style={{ fontSize: '11px', marginLeft: '10%' }}>
          {title}
        </div>
      )}
      <br />
      <table className="table" style={{ width: '80%', marginLeft: '10%' }}>
        <tbody>
          {elementObject
            ? elementObject.map(
                (item) =>
                  item &&
                  typeof item === 'object' &&
                  Object.entries(item).map(
                    ([key, value]: [key: any, value: any]) => (
                      <tr key={key}>
                        <td
                          className={
                            key === 'vault_location_after_re_arrangement' ||
                            key === 'vault_location_before_re_arrangement'
                              ? 'center-content'
                              : 'table-td-key'
                          }
                          rowSpan={
                            key === 'vault_location_after_re_arrangement' ||
                            key === 'vault_location_before_re_arrangement'
                              ? 2
                              : 0
                          }
                        >
                          {label[key as keyof typeof label] ||
                            key
                              .replaceAll('_', ' ')
                              .replace(/^(.)/, (match: any) =>
                                match.toUpperCase(),
                              )}
                        </td>
                        {!(
                          key === 'vault_location_after_re_arrangement' ||
                          key === 'vault_location_before_re_arrangement'
                        ) && (
                          <td className="table-td-value">
                            :{' '}
                            {value
                              ?.replaceAll('_', ' ')
                              ?.replace(/^(.)/, (match: any) =>
                                match.toUpperCase(),
                              )}
                          </td>
                        )}
                      </tr>
                    ),
                  ),
              )
            : null}
        </tbody>
      </table>
    </body>
  </html>
);

const signStyles = `
* {
  font-size: 10px;
}
#container {
  margin: 0% 10%;
}
.text-center {
  text-align: center;
}
.center-content {
  text-align: center;
}
`;

export const SignatureRenderComponent: React.FC = () => (
  <html>
    <style>{signStyles}</style>
    <body>
      <div id="container">
        <br />
        <br />
        <br />
        <table>
          <tbody>
            <tr>
              <td>PROCESS RELATED REMARKS FOR NFDC-NFAI:</td>
            </tr>
            <tr style={{ margin: '50px 0px' }}>
              <td>
                <img
                  src={
                    'https://res.cloudinary.com/drvaemi9t/image/upload/v1697604448/gv0toiytuxwfvd6pd7ob.png' 
                  }
                  alt="logo"
                  className="image-align"
                  style={{ width: '50%', marginLeft: '70px' }}
                />
                <div className="center-content">
                  Shilpa Vasekar
                  <br />
                  Supervisor
                  <br />
                  Prasad Corporation Pvt Ltd
                </div>
              </td>
              <td>
                <img
                  src={
                    'https://res.cloudinary.com/drvaemi9t/image/upload/v1697604555/lbncr7sqndrbb7mtcq9n.png'
                  }
                  alt="logo"
                  className="image-align"
                  style={{ width: '50%', marginLeft: '70px' }}
                />
                <div className="center-content">
                  S.Venkatakrishnan
                  <br />
                  Sr. Supervisor
                  <br />
                  Prasad Corporation Pvt Ltd
                </div>
              </td>
            </tr>
            <tr style={{ margin: '50px 0px' }}>
              <td>
                <img
                  src={
                    'https://res.cloudinary.com/drvaemi9t/image/upload/v1697604639/txtpdjp7mxloerppn7ch.png'
                  }
                  alt="logo"
                  className="image-align"
                  style={{ width: '50%', marginLeft: '70px' }}
                />
                <div className="center-content">
                  Sujit L. Suvarna
                  <br />
                  Domestic Project Manager
                  <br />
                  Prasad Corporation Pvt Ltd
                </div>
              </td>
              <td>
                <img
                  src={
                    'https://res.cloudinary.com/drvaemi9t/image/upload/v1697604701/ghgofpbjfhhirmgydlgo.png'
                  }
                  alt="logo"
                  className="image-align"
                  style={{ width: '50%', marginLeft: '70px' }}
                />
                <div className="center-content">
                  Christin Lur in <br />
                  International Project Manager
                </div>
              </td>
            </tr>
            <tr style={{ margin: '50px 0px' }}>
              <br />
              <br />
              <br />
              <td>
                Leenali Khairnar <br />
                NFDC
              </td>
              <td>
                Bhavesh Singh <br />
                NFDC
              </td>
              <td>
                Shreelekha Chauhan <br />
                NFHM PMU
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </body>
  </html>
);
